import React, { useState } from 'react';
import { CalculatorIcon, ChevronRightIcon } from '@heroicons/react/24/outline';
import { getConfig, resolveFileUrl as resolveFullUrl } from '../services/configManager';
import { useAppState } from '../hooks/useAppState';
import EstimateFeeModal from './EstimateFeeModal';

const CalculatorCard: React.FC = () => {
  const config = getConfig();
  const enabled = config.FEATURES.Calculator?.Enabled ?? true;
  const ratesEnabled = config.FEATURES.Rates?.Enabled ?? true;
  const ratesUrl = resolveFullUrl(config.ASSETS.FILES.RATES);
  const { state } = useAppState();

  const [modalOpen, setModalOpen] = useState(false);

  if (!enabled) return null;

  const rate = state.currentTicket?.meta?.rate;
  const entryDate = state.currentTicket?.entryDate;

  return (
    <>
      <button
        type="button"
        onClick={() => rate && entryDate && setModalOpen(true)}
        className="flex items-center gap-2.5 w-full px-3 py-2.5 my-1 bg-blue-50 border border-blue-100 rounded-[9px] cursor-pointer select-none transition-all duration-150 hover:bg-blue-100 hover:border-blue-200 hover:shadow-md active:scale-[0.985] focus-visible:outline-2 focus-visible:outline-primary-btn focus-visible:outline-offset-2"
      >
        <span className="flex-none flex text-primary-btn">
          <CalculatorIcon className="w-4 h-4" />
        </span>
        <span className="flex-1 text-left">
          <span className="block text-[13px] font-semibold text-black">
            How much will I pay?
          </span>
          {ratesEnabled && ratesUrl && (
            <a
              href={ratesUrl}
              target="_blank"
              rel="noopener noreferrer"
              onClick={(e) => e.stopPropagation()}
              className="inline-block text-[11.5px] font-medium text-primary-btn mt-px hover:underline cursor-pointer"
            >
              View rate sheet
            </a>
          )}
        </span>
        <ChevronRightIcon className="flex-none w-4 h-4 text-primary-btn" />
      </button>

      {rate && entryDate && (
        <EstimateFeeModal
          isOpen={modalOpen}
          onClose={() => setModalOpen(false)}
          entryDate={entryDate}
          rate={rate}
        />
      )}
    </>
  );
};

export default CalculatorCard;
